import React, {Component} from 'react';
import logo from './images/logo.png'
import schriftzug from './images/dba-schriftzug.png'
import './App.scss';
import { Link, withRouter } from "react-router-dom";
import SecondaryNav from "./SecondaryNav"
import PrimaryNav from "./PrimaryNav"
import MobileHeader from "./MobileHeader";

class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            collapsed: true
        }
    }

    componentDidMount() {
        this.props.history.listen((location, action) => {
            this.closeBurgerMenu();
        })
    }

    userCanViewSecondaryNav = () => {
        return /categories/.test(window.location.href);
    };

    toggleBurgerMenu = () => {
        this.setState(state => ({ collapsed: !state.collapsed}));
    };

    closeBurgerMenu = () => {
        this.setState({collapsed: true});
    };

    render() {
        return (
            <>
                {/*  DESKTOP HEADER */}
                <div className="header desktop-header">
                    <div className="row" id={"desktop-header-primary-row"} >
                        <div className="logo-container">
                            <Link to="/" id={"dba-logo-link"}>
                                <img id={"dba-logo"} src={logo} className="logo" alt="logo"/>
                            </Link>
                        </div>
                        <div className="primary-nav-container" >
                            <Link to="/">
                                <img id={"dba-schriftzug"} className="office-name" src={schriftzug} alt="dba-schriftzug"/>
                            </Link>

                            <PrimaryNav />
                        </div>
                    </div>


                    {this.userCanViewSecondaryNav() && (
                        <SecondaryNav/>
                    )}
                </div>

                {/*  MOBILE HEADER */}
                <MobileHeader />
            </>
        );
    }
}

export default withRouter(Header);
